import React from 'react';

import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const InactiveEquipmentModal = ({ text }) => {
  const { t } = useTranslation();
  const { setModalClose } = useModalActions();

  return (
    <div className={style.inActiveModal}>
      <ModalHeader />
      <div className={style.modalBody}>
        <div className={style.modalBodyTitle}>{t('This equipment is not being monitored.')}</div>
        <div className={style.modalBodyText}>
          <div>
            {t('It was deactivated by {user} on {date}', {
              user: text.createdBy,
              date: text.deactivatedTime,
            })}
          </div>

          {text.activeTime ? (
            <div>{t('Equipment will be active from {date}', { date: text.activeTime })}</div>
          ) : (
            <div>{t('This equipment will be deactivated indefinitely')}</div>
          )}
        </div>
      </div>
      <div className={style.modalFooter}>
        <Button type="primary" text={t('Ok')} onClick={setModalClose} />
        <Button type="secondary" text={t('Cancel')} onClick={setModalClose} />
      </div>
    </div>
  );
};

export default InactiveEquipmentModal;
